import Vue from 'vue'
import VueRouter from 'vue-router'

import DepartmentLevel from '@/views/tiep-nhan-du-lieu-QLNT/cau-hinh-lich-dong-bo/cap-so'
import SchoolLevel from '@/views/tiep-nhan-du-lieu-QLNT/cau-hinh-lich-dong-bo/cap-truong'

import ProvincialDataSubmissionReport from '@/views/tiep-nhan-du-lieu-QLNT/bao-cao-tinh-hinh-nop-du-lieu/cap-so'
import SchoolDataSubmissionReport from '@/views/tiep-nhan-du-lieu-QLNT/bao-cao-tinh-hinh-nop-du-lieu/cap-truong'

import { getFromSessionStorage } from '@/utils/session'

import { path } from './path'

Vue.use(VueRouter)

const routes = [
    {
        path: path.login,
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: {
            title: 'Login'
        }
    },
    {
        path: path.not_found,
        name: 'NotFound',
        component: () => import('@/views/404.vue'),
        meta: {
            title: 'NotFound'
        }
    },

    {
        path: path.dashboard,
        name: 'DashBoard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: {
            title: 'Dash Board'
        }
    },
    {
        path: path.index,
        redirect: '/dashboard'
    },

    // <!-- ************ tiep-nhan-du-lieu-QLNT ************ -->

    //  cau-hinh-lich-dong-bo
    {
        path: path.configure_sync_calendar,
        name: 'ConfigureSyncCalendar',
        component: {
            render() {
                // Lấy giá trị type từ route
                const type = this.$route.query.type || 1

                if (type == 1) {
                    return <DepartmentLevel />
                } else if (type == 2) {
                    return <SchoolLevel />
                } else {
                    return <div>Thành phần không tồn tại</div>
                }
            }
        },
        meta: {
            title: ''
        }
    },

    {
        path: '/update-school-partners',
        name: 'SchoolPartners',

        component: () =>
            import(
                '@/views/tiep-nhan-du-lieu-QLNT/he-thong-doi-tac-truong/index.vue'
            ),
        meta: {
            title: 'Hệ thống đối tác trường'
        }
    },

    {
        path: path.report_sync_status,
        name: 'ReportSyncStatus',

        component: {
            render() {
                const type = this.$route.query.type || 1

                if (type == 1) {
                    return <ProvincialDataSubmissionReport />
                } else if (type == 2) {
                    return <SchoolDataSubmissionReport />
                } else {
                    return <div>Thành phần không tồn tại</div>
                }
            }
        },
        meta: {
            title: ''
        }
    },

    {
        path: path.data_transfer_schedule,
        name: 'DataTransferSchedule',

        component: () =>
            import(
                '@/views/tiep-nhan-du-lieu-QLNT/lich-su-tiep-nhan-du-lieu/index.vue'
            ),
        meta: {
            title: 'Lịch sử tiếp nhận dữ liệu'
        }
    },

    {
        path: path.pass_data_transfer,
        name: 'PassDataTransfer',

        component: () =>
            import(
                '@/views/ket-chuyen-du-lieu-len-bo/mat-khau-ket-chuyen/index.vue'
            ),
        meta: {
            title: 'Mật khẩu kết chuyển'
        }
    },

    {
        path: path.pass_data_transfer_ioc,
        name: 'PassDataTransferIOC',

        component: () =>
            import(
                '@/views/ket-chuyen-du-lieu-len-bo/mat-khau-ket-chuyen-ioc/index.vue'
            ),
        meta: {
            title: 'Mật khẩu kết chuyển IOC'
        }
    },

    {
        path: path.config_moet_transfer_permission,
        name: 'ConfigMoetTransferPermission',

        component: () =>
            import(
                '@/views/ket-chuyen-du-lieu-len-bo/cau-hinh-duyet-day-du-lieu/index.vue'
            ),
        meta: {
            title: 'Cấu hình duyệt đẩy dữ liệu lên Bộ'
        }
    },

    {
        path: path.request_data_by_school,
        name: 'RequestDataBySchool',

        component: () =>
            import(
                '@/views/ket-chuyen-du-lieu-len-bo/ket-chuyen-du-lieu/index.vue'
            ),
        meta: {
            title: 'Kết chuyển dữ liệu'
        }
    },

    {
        path: path.request_data_by_school_ioc,
        name: 'RequestDataBySchoolIOC',

        component: () =>
            import(
                '@/views/ket-chuyen-du-lieu-len-bo/ket-chuyen-du-lieu-ioc/index.vue'
            ),
        meta: {
            title: 'Kết chuyển dữ liệu IOC'
        }
    },

    {
        path: path.moet_transfer_history,
        name: 'MoetTransferHistory',

        component: () =>
            import(
                '@/views/ket-chuyen-du-lieu-len-bo/lich-su-day-du-lieu-len-bo/index.vue'
            ),
        meta: {
            title: 'Lịch sử đẩy dữ liệu lên bộ'
        }
    },

    {
        path: path.moet_transfer_history_ioc,
        name: 'MoetTransferHistoryIOC',

        component: () =>
            import(
                '@/views/ket-chuyen-du-lieu-len-bo/lich-su-day-du-lieu-len-ioc/index.vue'
            ),
        meta: {
            title: 'Lịch sử đẩy dữ liệu lên IOC'
        }
    },

    {
        path: path.report.department,
        name: 'ReportToTheDepartment',

        component: () => import('@/views/bao-cao/bao-cao-don-vi/index.vue'),
        meta: {
            title: 'Báo cáo đơn vị'
        }
    },

    {
        path: path.report.dynamic_report.staff_report,
        name: 'StaffReport',

        component: () =>
            import('@/views/bao-cao/bao-cao-dong/bao-cao-can-bo/index.vue'),
        meta: {
            title: 'Báo cáo cán bộ'
        }
    },
    {
        path: path.report.dynamic_report.student_report,
        name: 'StudentReport',

        component: () =>
            import('@/views/bao-cao/bao-cao-dong/bao-cao-hoc-sinh/index.vue'),
        meta: {
            title: 'Báo cáo học sinh'
        }
    },
    {
        path: path.report.dynamic_report.school_report,
        name: 'SchoolReport',

        component: () =>
            import('@/views/bao-cao/bao-cao-dong/bao-cao-truong-hoc/index.vue'),
        meta: {
            title: 'Báo cáo trường học'
        }
    },

    {
        path: path.report.emis.begin,
        name: 'EmisYearStartReport',

        component: () =>
            import('@/views/bao-cao/bao-cao-emis/bao-cao-dau-nam/index.vue'),
        meta: {
            title: 'Báo cáo Emis'
        }
    },

    {
        path: path.report.emis.last,
        name: 'EmisYearEndReport',

        component: () =>
            import('@/views/bao-cao/bao-cao-emis/bao-cao-cuoi-nam/index.vue'),
        meta: {
            title: 'Báo cáo Emis'
        }
    },
    {
        path: path.report.eqms,
        name: 'Report-eqms',

        component: () => import('@/views/bao-cao/bao-cao-eqms/index.vue'),
        meta: {
            title: 'Báo cáo Eqms'
        }
    },

    {
        path: path.report.graduation_report,
        name: 'GraduationReport',

        component: () => import('@/views/bao-cao/bao-cao-moi/index.vue'),
        meta: {
            title: 'Báo cáo mới'
        }
    },

    {
        path: path.report.submit_statistical_sample,
        name: 'SubmitStatisticalSample',

        component: () =>
            import('@/views/bao-cao/nop-thong-ke-theo-bieu-mau/index.vue'),
        meta: {
            title: 'Nộp thống kê theo biểu mẫu'
        }
    },

    {
        path: path.report.data_synchronization,
        name: 'DataSynchronization',

        component: () =>
            import('@/views/bao-cao/tong-hop-du-lieu-bao-cao/index.vue'),
        meta: {
            title: 'Tổng hợp dữ liệu báo cáo'
        }
    },

    {
        path: path.report.data_synchronization_emis,
        name: 'DataSynchronizationEmis',

        component: () =>
            import('@/views/bao-cao/tong-hop-du-lieu-bao-cao-emis/index.vue'),
        meta: {
            title: 'Tổng hợp dữ liệu báo cáo emis'
        }
    },

    {
        path: path.report.latch_data_report.latch_school,
        name: 'LatchSchool',

        component: () =>
            import(
                '@/views/bao-cao/chot-du-lieu-bao-cao/chot-theo-truong/index.vue'
            ),
        meta: {
            title: 'Chốt dữ liệu báo cáo'
        }
    },

    {
        path: path.lock_up.school.home,
        name: 'LookUpSchool',

        component: () => import('@/views/tra-cuu/tra-cuu-truong-hoc/index.vue'),
        meta: {
            title: 'Tra cứu trường học'
        }
    },

    {
        path: path.lock_up.school.add_school,
        name: 'AddLookUpSchool',

        component: () => import('@/views/tra-cuu/tra-cuu-truong-hoc/add.vue'),
        meta: {
            title: 'Tra cứu thêm mới trường học'
        }
    },
    {
        path: `${path.lock_up.school.update_school}/:id`,
        name: 'UpdateLookUpSchool',

        component: () =>
            import('@/views/tra-cuu/tra-cuu-truong-hoc/update/index.vue'),
        meta: {
            title: 'Tra cứu chỉnh sửa trường học'
        }
    },

    {
        path: path.lock_up.teacher.home,
        name: 'LookUpOfficials',

        component: () =>
            import('@/views/tra-cuu/tra-cuu-can-bo-giao-vien/index.vue'),
        meta: {
            title: 'Tra cứu giáo viên'
        }
    },
    {
        path: `${path.lock_up.teacher.update_teacher}/:id`,
        name: 'UpdateLookUpOfficials',

        component: () =>
            import('@/views/tra-cuu/tra-cuu-can-bo-giao-vien/update/index.vue'),
        meta: {
            title: 'Tra cứu chỉnh sửa giáo viên'
        }
    },

    {
        path: path.lock_up.class.home,
        name: 'LookUpClasses',

        component: () => import('@/views/tra-cuu/tra-cuu-lop-hoc/index.vue'),
        meta: {
            title: 'Tra cứu lớp học'
        }
    },
    {
        path: `${path.lock_up.class.update_class}/:id`,
        name: 'UpdateLookUpClasses',

        component: () =>
            import('@/views/tra-cuu/tra-cuu-lop-hoc/update/index.vue'),
        meta: {
            title: 'Tra cứu chỉnh sửa lớp học'
        }
    },

    {
        path: path.lock_up.student.home,
        name: 'LookUpStudent',

        component: () => import('@/views/tra-cuu/tra-cuu-hoc-sinh/index.vue'),
        meta: {
            title: 'Tra cứu học sinh'
        }
    },
    {
        path: `${path.lock_up.student.update_student}/:id`,
        name: 'UpdateLookUpStudent',

        component: () =>
            import('@/views/tra-cuu/tra-cuu-hoc-sinh/update/index.vue'),
        meta: {
            title: 'Tra cứu chỉnh sửa học sinh'
        }
    },

    {
        path: path.lock_up.profileStudent.home,
        name: 'LookUpProfileStudent',

        component: () =>
            import('@/views/tra-cuu/tra-cuu-ho-so-hoc-sinh/index.vue'),
        meta: {
            title: 'Tra cứu hồ sơ học sinh'
        }
    },
    {
        path: `${path.lock_up.profileStudent.update_profile_student}/:id`,
        name: 'ViewLookUpProfileStudent',

        component: () =>
            import('@/views/tra-cuu/tra-cuu-ho-so-hoc-sinh/info/index.vue'),
        meta: {
            title: 'Tra cứu hồ sơ học sinh'
        }
    },

    {
        path: path.lock_up.academiResults.home,
        name: 'LockUpAcademiResults',
        component: () =>
            import('@/views/tra-cuu/tra-cuu-ket-qua-hoc-tap/index.vue'),
        meta: {
            title: 'Tra cứu kết quả học tập'
        }
    },
    {
        path: `${path.lock_up.academiResults.update_academi_results}/:id`,
        name: 'UpdateLookUpAcademiResults',

        component: () =>
            import('@/views/tra-cuu/tra-cuu-ket-qua-hoc-tap/info/index.vue'),
        meta: {
            title: 'Tra cứu kết quả học tập'
        }
    },

    {
        path: path.lock_up.attendance,
        name: 'LockUpAttendance',

        component: () => import('@/views/tra-cuu/thong-tin-diem-danh/index.vue'),
        meta: {
            title: 'Thông tin điểm danh'
        }
    },

    {
        path: path.lock_up.history_delete,
        name: 'LookUpHistoryDelete',

        component: () =>
            import('@/views/tra-cuu/tra-cuu-lich-su-xoa-du-lieu/index.vue'),
        meta: {
            title: 'Tra cứu lịch sử xóa dữ liệu'
        }
    },

    {
        path: path.lock_up.history_transfer_school,
        name: 'LockUpHistoryTransferSchool',

        component: () =>
            import('@/views/tra-cuu/quan-ly-danh-sach-chuyen-truong/index.vue'),
        meta: {
            title: 'Quản lý danh sách chuyển trường'
        }
    },

    {
        path: path.system.user_management,
        name: 'UserManagement',
        component: () => import('@/views/he-thong/quan-ly-nguoi-dung/index.vue'),
        meta: {
            title: 'Quản lí người dùng'
        }
    },

    {
        path: path.system.role_management,
        name: 'RoleManagement',

        component: () => import('@/views/he-thong/quan-ly-vai-tro/index.vue'),
        meta: {
            title: 'Quản lí vai trò'
        }
    },

    {
        path: path.system.merge_schools,
        name: 'MergeSchools',
        component: () => import('@/views/he-thong/sap-nhap-truong-hoc/index.vue'),
        meta: {
            title: 'Sáp nhập trường học'
        }
    },

    {
        path: path.system.dissolve_schools,
        name: 'DissolveSchools',
        component: () => import('@/views/he-thong/giai-the-truong-hoc/index.vue'),
        meta: {
            title: 'Giải thể trường học'
        }
    },

    {
        path: path.system.partner_management,
        name: 'PartnerManagement',
        component: () => import('@/views/he-thong/quan-ly-doi-tac/index.vue'),
        meta: {
            title: 'Quản lý đối tác'
        }
    },

    {
        path: path.category.province,
        name: 'CategoryProvince',
        component: () => import('@/views/danh-muc/tinh-thanh/index.vue'),
        meta: {
            title: 'Tỉnh thành'
        }
    },

    {
        path: path.category.district,
        name: 'CategoryDistrict',
        component: () => import('@/views/danh-muc/quan-huyen/index.vue'),
        meta: {
            title: 'Quận huyện'
        }
    },

    {
        path: path.category.wards,
        name: 'CategoryWards',
        component: () => import('@/views/danh-muc/phuong-xa/index.vue'),
        meta: {
            title: 'Phường/Xã'
        }
    },

    {
        path: path.category.village,
        name: 'CategoryVillage',
        component: () => import('@/views/danh-muc/to-thon/index.vue'),
        meta: {
            title: 'Tổ thôn'
        }
    },

    {
        path: path.account.user.view,
        name: 'AccountUser',
        component: () =>
            import('@/views/tai-khoan/thong-tin-tai-khoan/index.vue'),
        meta: {
            title: 'Thông tin tài khoản'
        }
    },

    {
        path: path.account.loginHistory,
        name: 'LoginHistory',
        component: () => import('@/views/tai-khoan/lich-su-dang-nhap/index.vue'),
        meta: {
            title: 'Lịch sử đăng nhập'
        }
    },

    {
        path: path.profile.base,
        redirect: '/profile/teacher'
    },

    {
        path: path.profile.teacher,
        name: 'TeacherProfile',
        component: () => import('@/views/ho-so-new/giao-vien/index.vue'),
        meta: {
            title: 'Hồ sơ giáo viên'
        }
    },

    {
        path: path.profile.student,
        name: 'StudentProfile',
        component: () => import('@/views/ho-so-new/hoc-sinh/index.vue'),
        meta: {
            title: 'Hồ sơ học sinh'
        }
    },

    {
        path: path.profile.school,
        name: 'SchoolProfile',
        component: () => import('@/views/ho-so-new/truong-hoc/index.vue'),
        meta: {
            title: 'Hồ sơ trường học'
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
const authMiddleware = (to, from, next) => {
    document.title = 'Đồng bộ CSDL'
    const token = getFromSessionStorage('auth_token')

    !token && to.path !== '/login' ? next('/login') : next()
}

router.beforeEach(authMiddleware)
export default router
